// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"231":"5a763981","828":"e5f17054","850":"2f64450a","937":"6bca8b41"}[chunkId] + ".js";
};